import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooCustomersView from "pages/retailer/retailers/OdooCustomersView";
import { ODOO_SAVE_CUSTOMER } from "./graphql";

const ConnectRetailerView = ({ order, hide }) => {
  console.log("order", order);
  const [saveCustomer, saveCustomerRes] = useMutation(ODOO_SAVE_CUSTOMER, {
    onCompleted() {
      Alert("success", "Customer connected successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_MT_ODOO_RETAILERS", "FETCH_MT_ODOO_REPGROUPS"],
    awaitRefetchQueries: true,
  });

  function onSelectHandler(customer) {
    if (window.confirm("Are you sure you want to connect this customer?")) {
      saveCustomer({
        variables: {
          instance: "INC",
          id: customer.id,
          xStudioMtRetailerId: order.retailerID,
          xStudioMtRepgroupId: order.repGroup.recordID,
        },
      });
    }
  }

  return (
    <div>
      {saveCustomerRes.loading ? (
        <InlineSpinner text="Connecting customer..." />
      ) : (
        <div>
          <div className="mb-2 text-xs opacity-70">
            Select a customer below from Odoo to connect to MarketTime retailer{" "}
            {order.billToName}. You just need to do this once.
          </div>
          <OdooCustomersView
            instance="INC"
            useType="LINK_CUSTOMER"
            onSelect={onSelectHandler}
            initialSearchText={order.billToName}
          />
        </div>
      )}
    </div>
  );
};

export default ConnectRetailerView;
